/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useMemo } from 'react';
import SavableDropdownField from '../../components/SavableDropdownField';
import { saveProductArea } from '../../actions/TicketActions';
import { useAppDispatch, useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
function ProductAreaField() {
  const dispatch = useAppDispatch();
  const productAreas = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticketExternalProperties.productAreas);
  const isSaving = useAppSelector(({
    zorseGrrTagging: state
  }) => state.actionStates.isSavingProductArea);
  const ticket = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  const options = useMemo(() => productAreas.map(obj => ({
    text: obj.name,
    value: obj.id
  })).sortBy(obj => obj.text).toArray(), [productAreas]);
  return /*#__PURE__*/_jsx(SavableDropdownField, {
    isRequired: true,
    isSaving: isSaving,
    labelLangPath: "app.panel.body.fields.labels.productArea",
    onOptionSelected: id => {
      dispatch(saveProductArea(ticket.id, productAreas.find(obj => obj.id === id)));
    },
    options: options,
    placeholderLangPath: "app.panel.body.fields.placeholders.choose",
    value: ticket.productArea && ticket.productArea.id
  });
}
export default ProductAreaField;